/* global axios */
import ApiClient from './ApiClient';
import { requestConfig, resourcePath, withQuery } from './lais/httpHelpers';

const deleteConfig = (payload = {}) => ({
  ...requestConfig(),
  data: payload,
});

class LaisCondominiosAPI extends ApiClient {
  constructor() {
    super('condominiums', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  listings(id) {
    return axios.get(resourcePath(this.url, id, 'listings'), requestConfig());
  }

  linkListing(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'link_listing'),
      {
        ...payload,
        source: payload.source || 'lais_condominios_console',
      },
      requestConfig()
    );
  }

  unlinkListing(id, imovelId, payload = {}) {
    return axios.delete(
      resourcePath(this.url, id, 'listings', imovelId),
      deleteConfig({
        ...payload,
        source: payload.source || 'lais_condominios_console',
      })
    );
  }

  searchListings(params = {}) {
    return axios.get(
      withQuery(resourcePath(this.baseUrl(), 'imoveis'), params),
      requestConfig()
    );
  }
}

export default new LaisCondominiosAPI();
